/* eslint-disable global-require */
/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './pages/**/*.{ts,tsx}',
    './components/**/*.{ts,tsx}',
    './app/**/*.{ts,tsx}',
    './src/**/*.{ts,tsx}',
    './utils/**/*.{ts,tsx}',
    './config/**/*.{js,ts,jsx,tsx,mdx}',
    './templates/**/*.{ts,tsx}',
  ],
  theme: {
    container: {
      center: true,
      padding: '2rem',
      screens: {
        '2xl': '1400px',
      },
    },
    extend: {
      transitionDuration: {
        400: '400ms',
        600: '600ms',
      },
      transitionTimingFunction: {
        'custom-hamburger-link': 'cubic-bezier(0.82, 0, 0.22, 0.99)',
        'custom-primary-button': 'cubic-bezier(0.74, 0, 0.32, 1)',
      },
      screens: {
        '3xl': '1920px',
        '4xl': '2160px',
        '5xl': '3160px',
      },
      maxWidth: {
        '2xs': '18rem',
        '3xs': '16rem',
      },
      keyframes: {
        'accordion-down': {
          from: { height: 0 },
          to: { height: 'var(--radix-accordion-content-height)' },
        },
        'accordion-up': {
          from: { height: 'var(--radix-accordion-content-height)' },
          to: { height: 0 },
        },
        'fade-in-slide': {
          from: { opacity: 0, transform: 'translateX(-20px)' },
          to: { opacity: 1, transform: 'translateX(0px)' },
        },
        'pulse-scale': {
          '0%, 100%': { transform: 'scale(1)' },
          '50%': { transform: 'scale(1.6)' },
        },
        'pulse-full': {
          '0%': { opacity: 0 },
          '40%': { opacity: 1 },
          '80%': { opacity: 0 },
          '100%': { opacity: 0 },
        },
        moveInFly: {
          '0%': {
            transform: 'translate(0px, 0px) rotate(0deg)',
          },
          '5%': {
            transform:
              'translate(calc(-0.2929 * 150px), calc(-0.2929 * 150px)) rotate(calc(5 * 3.6deg))',
          },
          '10%': {
            transform:
              'translate(calc(-0.5 * 150px), calc(-0.5 * 150px)) rotate(calc(10 * 3.6deg))',
          },
          '15%': {
            transform:
              'translate(calc(-0.7071 * 150px), calc(-0.7071 * 150px)) rotate(calc(15 * 3.6deg))',
          },
          '20%': {
            transform:
              'translate(calc(-1 * 150px), calc(-1 * 150px)) rotate(calc(20 * 3.6deg))',
          },
          '25%': {
            transform:
              'translate(calc(-1 * 150px), calc(-0.5 * 150px)) rotate(calc(25 * 3.6deg))',
          },
          '30%': {
            transform:
              'translate(calc(-1 * 150px), 0px) rotate(calc(30 * 3.6deg))',
          },
          '35%': {
            transform:
              'translate(calc(-1 * 150px), calc(0.5 * 150px)) rotate(calc(35 * 3.6deg))',
          },
          '40%': {
            transform:
              'translate(calc(-1 * 150px), 150px) rotate(calc(40 * 3.6deg))',
          },
          '45%': {
            transform:
              'translate(calc(-0.5 * 150px), 150px) rotate(calc(45 * 3.6deg))',
          },
          '50%': {
            transform: 'translate(0px, 150px) rotate(calc(50 * 3.6deg))',
          },
          '55%': {
            transform:
              'translate(calc(0.5 * 150px), 150px) rotate(calc(55 * 3.6deg))',
          },
          '60%': {
            transform: 'translate(150px, 150px) rotate(calc(60 * 3.6deg))',
          },
          '65%': {
            transform:
              'translate(150px, calc(0.5 * 150px)) rotate(calc(65 * 3.6deg))',
          },
          '70%': {
            transform: 'translate(150px, 0px) rotate(calc(70 * 3.6deg))',
          },
          '75%': {
            transform:
              'translate(150px, calc(-0.5 * 150px)) rotate(calc(75 * 3.6deg))',
          },
          '80%': {
            transform:
              'translate(150px, calc(-1 * 150px)) rotate(calc(80 * 3.6deg))',
          },
          '85%': {
            transform:
              'translate(calc(0.7071 * 150px), calc(-0.7071 * 150px)) rotate(calc(85 * 3.6deg))',
          },
          '90%': {
            transform:
              'translate(calc(0.5 * 150px), calc(-0.5 * 150px)) rotate(calc(90 * 3.6deg))',
          },
          '95%': {
            transform:
              'translate(calc(0.2929 * 150px), calc(-0.2929 * 150px)) rotate(calc(95 * 3.6deg))',
          },
          '100%': {
            transform: 'translate(0px, 0px) rotate(360deg)',
          },
        },
        blink: {
          '0%': { opacity: 1 },
          '50%': { opacity: 0.7 },
          '100%': { opacity: 1 },
        },
      },
      animation: {
        'accordion-down': 'accordion-down 0.2s ease-out',
        'accordion-up': 'accordion-up 0.2s ease-out',
        'fade-in-slide': 'fade-in-slide 0.2s ease-out',
        'pulse-full': 'pulse-full 1s ease-in-out infinite',
        'pulse-scale': 'pulse-scale 1.8s ease-in-out infinite',
        'move-in-fly':
          'moveInFly 13s linear infinite, blink 7s infinite alternate',
      },
      boxShadow: {
        offer: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
        'big-moduls': '2px 4px 24px 0px rgba(117, 117, 117, 0.14)',
        full: 'inset 0 0 0px 1000px',
        custom: '0 0 0 2px',
        'review-card':
          '0px 12px 26px 0px rgba(48, 48, 48, 0.10), 0px 46px 46px 0px rgba(48, 48, 48, 0.09), 0px 104px 63px 0px rgba(48, 48, 48, 0.05), 0px 186px 74px 0px rgba(48, 48, 48, 0.01), 0px 290px 81px 0px rgba(48, 48, 48, 0.00)',
        community:
          '0px 4px 6px 0px rgba(99, 99, 99, 0.05), 0px 8px 12px 0px rgba(99, 99, 99, 0.05)',
      },
      fontSize: {
        'display-1': [
          '10.75rem',
          {
            lineHeight: '100%',
            fontWeight: 400,
            letterSpacing: '-0.5375rem',
          },
        ],
        'display-2': [
          '5.9375rem',
          {
            lineHeight: '100%',
            fontWeight: 400,
            letterSpacing: '-0.29688rem',
          },
        ],
        'display-3': [
          '4.4375rem',
          {
            lineHeight: '110%',
            fontWeight: 400,
            letterSpacing: '-0.22188rem',
          },
        ],
        'display-4': [
          '3.25rem',
          {
            lineHeight: '110%',
            fontWeight: 400,
            letterSpacing: '–0.1625rem',
          },
        ],
        h1: [
          '3.8125rem',
          { lineHeight: '110%', fontWeight: 400, letterSpacing: '-0.1525rem' },
        ],
        h2: [
          '2.8125rem',
          { lineHeight: '120%', fontWeight: 400, letterSpacing: '-0.05625rem' },
        ],
        h3: [
          '2.125rem',
          { lineHeight: '120%', fontWeight: 400, letterSpacing: '-0.02125rem' },
        ],
        h4: [
          '1.5625rem',
          { lineHeight: '120%', fontWeight: 400, letterSpacing: '-0.01563rem' },
        ],
        h5: [
          '1.1875rem',
          { lineHeight: '120%', fontWeight: 400, letterSpacing: '-0.01188rem' },
        ],
        'jb-h1': ['4.5rem', { letterSpacing: '-0.09rem', lineHeight: '120%' }],
        'jb-h1.5': [
          '3.5rem',
          { letterSpacing: '-0.105rem', lineHeight: '100%' },
        ],
        'jb-h2': [
          '3rem',
          {
            letterSpacing: '-0.06rem',
            lineHeight: '108.333%',
          },
        ],
        'jb-h3': [
          '2.25rem',
          { letterSpacing: '-0.045rem', lineHeight: '120%' },
        ],
        'jb-h4': [
          '1.5rem',
          {
            letterSpacing: '-0.03rem',
            lineHeight: '133.333%',
          },
        ],
        'jb-h5': [
          '1.25rem',
          { letterSpacing: '-0.025rem', lineHeight: '140%' },
        ],
        'jb-body-large': [
          '1rem',
          { lineHeight: '150%', letterSpacing: '-0.005rem' },
        ],
        'jb-body-medium': [
          '0.875rem',
          { lineHeight: '120%', letterSpacing: '-0.005rem' },
        ],
        'jb-body-small': [
          '0.75rem',
          { lineHeight: '120%', letterSpacing: '-0.005rem' },
        ],
        'jb-body-xsmall': [
          '0.625rem',
          { lineHeight: '120%', letterSpacing: '-0.005rem' },
        ],
        body: ['1rem', { lineHeight: '150%', fontWeight: 400 }],
        'body-small': ['0.875rem', { lineHeight: '150%', fontWeight: 400 }],
        'jb-label-input': ['0.75rem', { lineHeight: 'normal' }],
        caption: ['0.75rem', { lineHeight: '150%', fontWeight: 400 }],
        pricing: [
          '2.4375rem',
          { lineHeight: '100%', fontWeight: 600, letterSpacing: '-0.12188rem' },
        ],
        faq: [
          '0.75rem',
          { lineHeight: '120%', fontWeight: 400, letterSpacing: '0.0075rem' },
        ],
        'jb-button-xl': ['1.125rem', { lineHeight: '177%' }],
        'jb-button-large': ['1rem', { lineHeight: '125%' }],
        'jb-button-medium': ['0.875rem', { lineHeight: '142.857%' }],
      },
      fontFamily: {
        sans: ['var(--font-work-sans)'],
        inter: ['var(--font-inter)'],
        workSans: ['var(--font-work-sans)'],
      },
      colors: {
        jb: {
          primary: {
            100: '#F7F4FF',
            200: '#E7DEFF',
            300: '#D0BDFF',
            400: '#895BFE',
            500: '#603DB5',
            600: '#3F2483',
          },
          neutral: {
            100: '#FFF',
            200: '#F9F9FB',
            300: '#F5F5F7',
            400: '#F3F3F5',
            500: '#D9D9D9',
            600: '#D5D6D8',
            700: '#636363',
            800: '#383838',
            900: '#292929',
            1000: '#202020',
          },
          success: {
            100: '#F1FDF3',
            200: '#D2F9D9',
            400: '#0F9B19',
            600: '#09530E',
          },
          alert: {
            100: '#FFF3F5',
            300: '#F9D2D4',
            400: '#FF4365',
            600: '#920E0E',
          },
          secondary: {
            100: '#FFFAF7',
            200: '#FFDFBB',
            300: '#FFC786',
            400: '#FFAB49',
            500: '#EE9124',
            600: '#995200',
          },
        },
        neutral: {
          0o0: '#FFFFFF',
          100: '#FAFAFA',
          200: '#EEEFF0',
          300: '#BFC6CC',
          400: '#A9B2B9',
          500: '#919BA3',
          600: '#7B858F',
          700: '#5E6A74',
          800: '#434D56',
          900: '#232C34',
          1000: '#1A2128',
        },
        primary: {
          100: '#E7DEFF',
          200: '#D0BDFF',
          300: '#B89DFE',
          400: '#A17CFE',
          500: '#895BFE',
          600: '#7049D5',
          700: '#5837AC',
          800: '#3F2483',
          900: '#27125A',
          1000: '#0E0031',
        },
        secondary: {
          100: '#D8E7FF',
          300: '#4894FF',
          500: '#006EFA',
          700: '#003F9A',
          900: '#001435',
        },
        successDark: '#23771C',
        success: '#3BA533',
        warning: '#FF9900',
        jobBoardSuccessStroke: '#0F9B19',
        jobBoardSuccessText: '#09530E',
        jobBoardSuccessBackground: '#F1FDF3',
        buttonCNC: '#7A46FF',
        uploadCNC: '#1D1841',
        iconsCNC: '#F1F1F1',
        error: {
          DEFAULT: '#DB3C58',
          '20%': '#DB3C5833',
          '36%': '#DB3C585C',
          '52%': '#DB3C5885',
          '68%': '#DB3C58AD',
          '84%': '#DB3C58D6',
        },
      },
      flex: {
        2: '2 2 0%',
        3: '3 3 0%',
        4: '4 4 0%',
        5: '5 5 0%',
      },
      backgroundImage: {
        'dots-black':
          'radial-gradient(lightgray 1px, lightgray 3px, transparent 3px)',
        'dark-gradient': 'linear-gradient(180deg, #001435 0%, #000 35.63%)',
        'candidate-gradient':
          'linear-gradient(156deg, rgba(245, 158, 11, 0.45) -2.64%, rgba(242, 72, 34, 0.63) 13.83%, rgba(198, 28, 129, 0.63) 43.95%, rgba(119, 75, 255, 0.72) 81.16%)',
        'navigation-recruiters':
          'linear-gradient(270deg, rgba(136, 90, 253, 0.10) 11.7%, rgba(0, 25, 63, 0.10) 100%)',
        'jb-primary-gradient':
          'linear-gradient(92deg, #895BFE 0%, #C542B1 46.5%, #E87556 100%)',
        'resume-background': 'url("/Macbook-1-scaled-1.webp")',
        'primary-gradient': 'linear-gradient(270deg, #885AFD, #00193F)',
        'primary-gradient-light': 'linear-gradient(270deg, #3755E0, #561DE2)',
        grid: 'url("/Grid-1-scaled.webp")',
        'candidate-landing-background':
          'linear-gradient(175deg, #010102 -13.33%, rgba(29, 7, 81, 0.80) 86.9%, #FFF 163.15%)',
        'candidate-gradient-border': `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3e%3cdefs%3e%3clinearGradient id='borderGradient' x1='0' y1='0' x2='1' y2='0'%3e%3cstop offset='0%25' stop-color='%23895BFE'/%3e%3cstop offset='50%25' stop-color='%23C542B1'/%3e%3cstop offset='100%25' stop-color='%23E87556'/%3e%3c/linearGradient%3e%3c/defs%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='url(%23borderGradient)' stroke-width='8' stroke-linecap='square'/%3e%3c/svg%3e")`,
        'candidate-gradient-border-sm': `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3e%3cdefs%3e%3clinearGradient id='borderGradient' x1='0' y1='0' x2='1' y2='0'%3e%3cstop offset='0%25' stop-color='%23895BFE'/%3e%3cstop offset='50%25' stop-color='%23C542B1'/%3e%3cstop offset='100%25' stop-color='%23E87556'/%3e%3c/linearGradient%3e%3c/defs%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='url(%23borderGradient)' stroke-width='2' stroke-linecap='square'/%3e%3c/svg%3e")`,
        academy:
          'linear-gradient(90deg, rgba(245, 158, 11, 0.70) 0%, rgba(242, 72, 34, 0.70) 35%, rgba(198, 28, 129, 0.70) 70.5%, rgba(103, 63, 215, 0.70) 95%)',
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic':
          'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
        'dashed-border-add-cv': `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%237049D5FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
        'dashed-border-add-resume-builder': `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23000000' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
        'hr-bots-dashed-border': `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%237B858FFF' stroke-width='2' stroke-dasharray='20 40' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
        'jb-highlight-orange': `url("data:image/svg+xml,%3Csvg viewBox='0 0 71 27' preserveAspectRatio='none' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.4536 10C19.7993 10.6003 26.0729 10.35 32.427 10.35C35.5488 10.35 38.6349 9.65807 41.7595 10.2722C43.4653 10.6075 45.2216 10 46.9396 10C48.3922 10 49.8449 10 51.2975 10C54.0135 10 56.815 10.1708 59.5097 10.6806C59.9001 10.7544 61 10.435 61 11.575C61 12.7236 57.4928 13.1252 56.8888 13.15C53.3685 13.2948 49.7559 13.8979 46.2407 14.6278C39.6296 16.0005 33.0189 13.85 26.4246 13.85C23.8893 13.85 21.3541 13.85 18.8188 13.85C17.1485 13.85 15.4945 14.2 13.8237 14.2C12.9575 14.2 11.7931 13.8536 10.9664 14.375C10.7474 14.5131 9.39625 14.7013 10.3188 14.9194C12.1703 15.3573 13.9414 15.6 15.8176 15.6C18.531 15.6 21.2444 15.6 23.9578 15.6C26.9585 15.6 29.9572 16.3 32.9717 16.3C37.0622 16.3 41.1719 16.65 45.2746 16.65C50.158 16.65 55.0152 17 59.89 17' stroke='%23FFC786' stroke-width='20' stroke-linecap='round' /%3E%3C/svg%3E")`,
        'jb-white-ellipse': `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1128' height='831' viewBox='0 0 1128 831' fill='none'%3E%3Cpath d='M1128 507.877C1128 815.156 965.023 831 653.352 831C341.681 831 0 815.156 0 507.877C0 200.599 252.861 0 564.532 0C876.203 0 1128 200.599 1128 507.877Z' fill='white'/%3E%3C/svg%3E%0A")`,
        'jb-hightlight-orange-alt': `url("data:image/svg+xml,%3Csvg preserveAspectRatio='none' viewBox='0 0 646 81' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M48.1746 65C124.49 59.9407 209.955 62.05 286.371 62.05C323.916 62.05 361.03 67.882 398.607 62.7056C419.123 59.8794 440.244 65 460.905 65C478.375 65 495.845 65 513.315 65C545.978 65 579.67 63.5607 612.077 59.2639C616.772 58.6413 630 61.334 630 51.725C630 42.0441 587.822 38.6594 580.557 38.45C538.221 37.2297 494.481 44.602 452.206 38.45C372.698 26.8798 292.923 42 214.185 32.55C183.695 32.55 153.205 32.55 122.715 32.55C102.628 32.55 91.0938 48.5 71 48.5C60.5836 48.5 34.5978 45.9035 24.6551 41.5093C22.0217 40.3454 9.39685 25.375 20.4921 23.5361C42.7584 19.8458 64.0579 17.8 86.622 17.8C119.254 17.8 151.887 17.8 184.519 17.8C220.607 17.8 255.747 16 292 16C341.193 16 391.16 16 440.5 16C499.23 16 556.874 16.9 615.5 16.9' stroke='%23FFC786' stroke-width='32' stroke-linecap='round'/%3E%3C/svg%3E%0A")`,
        'jb-hightlight-orange-alt2': `url("data:image/svg+xml,%3Csvg preserveAspectRatio='none' viewBox='0 0 462 62' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M45.8755 46C99.254 43.4275 152.025 44.5 205.475 44.5C231.735 44.5 257.694 47.4654 283.977 44.8333C298.327 43.3963 313.1 46 327.551 46C339.771 46 351.99 46 364.209 46C387.056 46 410.621 45.2681 433.288 43.0833C436.572 42.7668 445.824 44.1359 445.824 39.25C445.824 34.3275 416.323 32.6065 411.242 32.5C381.63 31.8795 351.036 35.6282 321.467 32.5C265.856 26.6168 210.453 29.5 154.984 29.5C133.658 29.5 112.332 29.5 91.0059 29.5C76.9556 29.5 63.0424 28 48.9879 28C41.7022 28 31.9073 29.4844 24.9529 27.25C23.111 26.6582 11.7456 25.8517 19.5062 24.9167C35.0802 23.0402 49.9781 22 65.7605 22C88.5851 22 111.41 22 134.234 22C159.476 22 184.7 19 210.057 19C244.465 19 279.035 17.5 313.545 17.5C354.624 17.5 395.481 16 436.487 16' stroke='%23FFC786' stroke-width='32' stroke-linecap='round'/%3E%3C/svg%3E%0A")`,
        'jb-highlight-blue':
          'url("data:image/svg+xml;base64,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")',
        'jb-highlight-green':
          'url("data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20109%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M39.5054%2011.4134C29.6909%2011.0818%2019.8364%2012.2935%2010.3368%2017.3812C10.1673%2017.4716%2010.097%2017.6494%2010.0831%2017.6901C10.0019%2017.9312%209.99319%2018.1874%2010.0035%2018.3984C10.0096%2018.5265%2010.0512%2019.0675%2010.2788%2019.1233C10.4359%2019.1609%2011.5515%2018.8972%2011.9819%2018.8294C14.008%2018.5114%2016.0301%2018.0578%2018.0511%2017.5334C22.6335%2016.3489%2027.2097%2015.3241%2031.7993%2014.3912C34.376%2013.8668%2036.9538%2013.4328%2039.53%2013.0771C45.7277%2013.2896%2051.9099%2014.1185%2057.9766%2014.9745C55.5652%2015.41%2053.3496%2015.8515%2051.5124%2016.1379C48.4143%2016.6201%2045.3219%2017.1898%2042.23%2017.9403C40.6415%2018.3246%2039.0549%2018.742%2037.4694%2019.2348C37.2938%2019.2906%2036.8937%2019.3478%2036.7001%2019.4156C36.6179%2019.4428%2036.5583%2019.4865%2036.5316%2019.5166C36.3642%2019.7065%2036.3431%2020.0953%2036.3411%2020.2912C36.34%2020.4103%2036.3539%2021.0598%2036.6364%2021.1864C49.7708%2027.1271%2063.4737%2020.2159%2076.6553%2025.9908C76.8099%2026.0586%2076.9548%2025.7451%2076.9779%2025.29C77.001%2024.8364%2076.8942%2024.4114%2076.7391%2024.3436C64.3242%2018.9048%2051.4467%2024.7204%2039.0159%2020.451C40.1022%2020.142%2041.189%2019.8632%2042.2768%2019.5995C45.363%2018.8505%2048.4498%2018.2824%2051.5427%2017.8001C54.6551%2017.3164%2058.8626%2016.3715%2063.2667%2015.7762C67.0463%2016.3941%2070.8239%2017.0873%2074.604%2017.675C76.1987%2017.9222%2077.794%2018.1271%2079.3882%2018.3788C80.0436%2018.4813%2081.7297%2018.9108%2081.9742%2018.751C82.1642%2018.626%2082.2099%2018.2266%2082.2212%2018.0262C82.2331%2017.8092%2082.2259%2017.5394%2082.1396%2017.2817C82.1129%2017.2003%2082.0328%2017.0315%2081.8684%2016.8929C77.4232%2013.157%2070.1444%2013.2158%2063.3273%2014.1185C61.861%2013.8773%2060.3946%2013.6483%2058.9278%2013.4418C55.5699%2012.9671%2052.1749%2012.4909%2048.7605%2012.1156C58.3829%2011.4179%2068.0098%2011.6183%2077.6394%2012.1232C81.6825%2012.3357%2092.5806%2013.6166%2096.8728%2014.7484C96.8204%2014.9066%2096.7896%2015.1267%2096.7932%2015.3663C96.8004%2015.8244%2096.9334%2016.1801%2097.0901%2016.159C97.9755%2016.0384%2098.4876%2015.8847%2098.6905%2015.7265C98.8168%2015.6285%2098.8856%2015.4718%2098.9175%2015.3693C98.9955%2015.1221%2099.0099%2014.8569%2098.9945%2014.6052C98.9847%2014.4485%2098.9606%2014.2767%2098.9051%2014.1185C98.8682%2014.01%2098.7778%2013.8442%2098.6237%2013.7312C96.9365%2012.4999%2082.4637%2010.7111%2077.6497%2010.4579C64.9282%209.79179%2052.2119%209.65617%2039.5054%2011.4134Z%22%20stroke%3D%22%23B3E2CD%22%20stroke-width%3D%2220%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E")',
        'jb-highlight-pink':
          'url("data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20146%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M63.5136%2011.4642C57.5941%2011.966%2051.7441%2012.5829%2046.0393%2013.2574C37.9636%2014.2116%2029.8911%2015.1987%2021.8672%2016.7616C19.3414%2017.2551%2016.7765%2017.5677%2014.2666%2018.1846C12.691%2018.5712%2010.6018%2019.1222%2010.3276%2019.2374C10.1842%2019.3032%2010.1216%2019.402%2010.1014%2019.4349C9.95928%2019.6652%209.98521%2019.8872%2010.0654%2020.06C10.0977%2020.134%2010.1791%2020.315%2010.4053%2020.3397C25.5307%2022.026%2040.9973%2018.7357%2056.141%2018.3902C82.403%2017.798%20109.461%2020.1505%20135.514%2025.2833C135.742%2025.3245%20135.963%2025.1188%20135.995%2024.8144C136.032%2024.5183%20135.868%2024.2304%20135.641%2024.1893C109.543%2019.0482%2082.4409%2016.6874%2056.1284%2017.2879C42.015%2017.6087%2027.6231%2020.496%2013.4902%2019.5089C13.8149%2019.4267%2014.1333%2019.3444%2014.4239%2019.2703C16.9237%2018.6534%2019.4779%2018.3491%2021.9936%2017.8555C30.0004%2016.2927%2038.0565%2015.3056%2046.1215%2014.3596C56.1284%2013.1751%2066.5713%2012.1552%2077.0963%2011.6781C80.8615%2011.7521%2084.6141%2011.8262%2088.3667%2011.9166C96.4847%2012.1141%20104.641%2012.6899%20112.74%2013.4631C115.178%2013.7016%20117.617%2013.9484%20120.055%2014.1622C120.864%2014.2363%20122.949%2014.4501%20123.239%2014.4336C123.6%2014.4172%20123.669%2014.0224%20123.675%2013.9566C123.694%2013.8085%20123.682%2013.6029%20123.505%2013.4301C123.486%2013.4055%20123.372%2013.3231%20123.119%2013.2738C108.393%2010.3619%2092.669%209.87668%2077.1089%2010.5759C60.696%2010.2715%2044.2199%2010.1398%2027.8486%2010C27.6143%2010%2027.4228%2010.2468%2027.4209%2010.5512C27.4197%2010.8555%2027.6086%2011.1023%2027.8429%2011.1105C39.6971%2011.2093%2051.6114%2011.3079%2063.5136%2011.4642Z%22%20stroke%3D%22%23F5B9BB%22%20stroke-width%3D%2220%22%2F%3E%3C%2Fsvg%3E")',
        'resume-bg': `url('data:image/svg+xml,<svg viewBox="0 0 1440 521" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-87.321 236.525C-48.9594 232.259 -8.23739 229.222 46.1892 227.319C437.869 213.625 661.979 269.987 998.634 288.841C1211.9 300.785 1518.39 299.559 1507.78 270.171" stroke="%23FFC786" stroke-width="450" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>')`,
      },
    },
  },
  plugins: [
    require('tailwindcss-animate'),
    require('@tailwindcss/container-queries'),
  ],
};
